const PLANS_DOMAIN = 'plans'

export default PLANS_DOMAIN
